import { motion } from "framer-motion";
import { whyChoose } from "../data/site";

export default function WhyChoose() {
    return (
        <section
            id="why"
            className="relative bg-[#0b0b0b] py-24 md:py-40 px-6 md:px-10 border-y border-[rgba(212,175,55,0.18)]"
            data-testid="why-section"
        >
            <div className="mx-auto max-w-[1440px]">
                <div className="flex items-center gap-6 mb-10">
                    <span className="w-16 h-px bg-[#C89B3C]" />
                    <span className="text-[10px] uppercase tracking-[0.4em] text-[#C89B3C]">
                        Chapter 11 — The Assurance
                    </span>
                </div>

                <div className="grid grid-cols-12 gap-6 items-end mb-16">
                    <motion.h2
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-15%" }}
                        transition={{ duration: 0.9 }}
                        className="col-span-12 lg:col-span-8 font-display font-light text-white text-5xl md:text-6xl lg:text-7xl leading-[0.95] tracking-tight"
                    >
                        Why choose <em className="text-[#E2C56D]">BRA Sheriff.</em>
                    </motion.h2>
                    <motion.p
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-15%" }}
                        transition={{ duration: 0.9, delay: 0.15 }}
                        className="col-span-12 lg:col-span-4 text-[#bebebe] text-base leading-relaxed font-light"
                    >
                        Six reasons families, investors and partners have trusted us for over
                        four decades.
                    </motion.p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 border-t border-[rgba(212,175,55,0.2)]">
                    {whyChoose.map((w, i) => (
                        <motion.div
                            key={w.n}
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-15%" }}
                            transition={{ duration: 0.7, delay: (i % 3) * 0.1 }}
                            className={`group relative p-10 md:p-12 border-b border-[rgba(212,175,55,0.2)] ${
                                (i + 1) % 3 !== 0
                                    ? "lg:border-r lg:border-[rgba(212,175,55,0.2)]"
                                    : ""
                            } ${
                                i % 2 === 0 ? "md:border-r md:border-[rgba(212,175,55,0.2)]" : ""
                            }`}
                            data-testid={`why-${i}`}
                        >
                            {/* Number */}
                            <div className="font-display text-6xl md:text-7xl text-[#C89B3C]/25 group-hover:text-[#E2C56D]/60 transition-colors leading-none">
                                {w.n}
                            </div>

                            <h3 className="mt-6 font-display font-light text-white text-2xl md:text-3xl leading-tight tracking-tight">
                                {w.title}
                            </h3>
                            <p className="mt-5 text-[#bebebe] text-sm md:text-base leading-relaxed font-light max-w-sm">
                                {w.body}
                            </p>

                            {/* Gold underline animation */}
                            <div className="mt-8 h-px w-8 bg-[#C89B3C] group-hover:w-24 transition-[width] duration-500" />
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
}
